import type { FC } from 'react'

import { cn } from '@/lib/utils'

interface WordmarkProps {
    /** Fondo sobre el que va: claro usa la versión carbón, oscuro la versión porcelana. */
    on?: 'light' | 'dark'
    className?: string
}

/** Logotipo original de fmg3d.cl. */
export const Wordmark: FC<WordmarkProps> = ({ on = 'light', className }) => {
    return (
        // eslint-disable-next-line @next/next/no-img-element
        <img
            src={on === 'light' ? '/brand/fmg3d-wordmark-light.svg' : '/brand/fmg3d-wordmark-dark.svg'}
            alt='FMG3D'
            width={1472}
            height={392}
            className={cn('h-8 w-auto', className)}
        />
    )
}

interface LogoMarkProps {
    className?: string
}

/** Símbolo de FMG3D en línea: las piezas oscuras toman el color del texto. */
export const LogoMark: FC<LogoMarkProps> = ({ className }) => {
    return (
        <svg viewBox='0 0 405 389' className={cn('size-8', className)} aria-hidden='true' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path fill='currentColor' d='M318.281 70.3438C280.031 73.4219 249.411 103.401 245.312 141.328C241.016 101.292 207.062 70.0885 165.87 70.0885C163.755 70.0885 161.641 70.151 159.589 70.3438C164.328 30.6875 198.031 0 238.901 0C279.776 0 313.542 30.6875 318.281 70.3438Z' />
            <path fill='currentColor' d='M157.281 229.422C117.307 233.844 86.2969 267.734 86.2969 308.865C86.2969 312.068 86.4896 315.271 86.875 318.411C84.6979 318.599 82.5833 318.667 80.3385 318.667C36.1979 318.667 0.447896 282.917 0.447896 238.776C0.447896 197.646 31.5208 163.755 71.5 159.333C31.3958 155.104 0.130188 121.151 0.130188 79.8906C0.130188 35.75 35.8802 0 80.0208 0C120.958 0 154.656 30.7552 159.333 70.3438C118.266 73.6771 85.9114 108.078 85.9114 149.979C85.9791 191.24 117.177 225.193 157.281 229.422Z' />
            <path fill='currentColor' d='M268.182 229.422C268.182 242.042 257.932 252.292 245.313 252.292C232.688 252.292 222.438 242.042 222.438 229.422C222.438 216.802 232.688 206.552 245.313 206.552C257.932 206.552 268.182 216.802 268.182 229.422Z' />
            <path fill='#FF6115' d='M333.339 229.422C373.443 225.13 404.708 191.172 404.708 149.979C404.708 105.839 368.891 70.0886 324.818 70.0886C322.635 70.0886 320.458 70.1511 318.281 70.3438C280.031 73.4219 249.412 103.401 245.313 141.328C241.016 101.292 207.063 70.0886 165.87 70.0886C163.755 70.0886 161.641 70.1511 159.589 70.3438C159.526 70.6667 159.526 70.9219 159.464 71.2448C159.464 70.9219 159.396 70.6667 159.333 70.3438C118.266 73.6771 85.9115 108.078 85.9115 149.979C85.9115 191.24 117.177 225.13 157.219 229.422C117.24 233.844 86.2344 267.734 86.2344 308.865C86.2344 312.068 86.4271 315.271 86.8125 318.411C91.5521 358.068 125.25 388.818 166.125 388.818C206.422 388.818 239.802 358.964 245.245 320.141C250.693 358.964 284.068 388.818 324.37 388.818C368.51 388.818 404.255 353.005 404.255 308.927C404.323 267.734 373.25 233.906 333.339 229.422ZM245.313 206.552C257.932 206.552 268.182 216.802 268.182 229.422C268.182 242.042 257.932 252.292 245.313 252.292C232.688 252.292 222.438 242.042 222.438 229.422C222.438 216.802 232.688 206.552 245.313 206.552Z' />
        </svg>
    )
}
